import { useRef } from "react";
import { Button, Modal } from "antd";
import { DownloadHTML } from "../../../utils/DownloadFile";
import { Aviso, textoDelPlazoParaSubsanar } from "../../../utils/avisosPostulacion";

interface IProps {
  visible: boolean;
  postulacion: any;
  convocatoria: any;
  nombrepropuesta: string;
  /** Lo administrativo que quedo por subsanar, si quedo algo. */
  pendientes?: Aviso[];
  /** Del cronograma, para decir hasta cuando hay plazo. */
  fechaDelInforme?: any;
  fechaLimiteSubsanar?: any;
  alAceptar: () => void;
}

/**
 * La confirmacion de que la propuesta quedo inscrita, con el detalle
 * descargable que sirve de constancia.
 *
 * Estaba dentro de la pagina de enlaces. Se saca para que el wizard muestre
 * exactamente la misma, y no dos confirmaciones que se parezcan.
 */
export const ModalPostulacionExitosa = ({
  visible,
  postulacion,
  convocatoria,
  nombrepropuesta,
  pendientes = [],
  fechaDelInforme,
  fechaLimiteSubsanar,
  alAceptar,
}: IProps) => {
  const plazo = textoDelPlazoParaSubsanar(fechaDelInforme, fechaLimiteSubsanar);
  const componentRef = useRef<any>();

  const handlePrint = () => {
    DownloadHTML(componentRef.current);
  };

  return (
        <Modal
          style={{ top: 60, zIndex: 3, background: "transparent" }}
          visible={visible}
          cancelButtonProps={{ style: { display: "none" } }}
          okButtonProps={{ style: { display: "none" } }}
          closable={false}
          closeIcon=""
          width={800}
          maskStyle={{
            zIndex: 3,
            background: "rgba(0,144,76,0.8)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="row-shadow">
            <div className="row">
              <div className="col-12 font-size-22px font-family-Montserrat-Bold d-flex justify-content-md-center texto_verde">
                Se ha completado el proceso
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-Regular justify-content-center">
                Felicidades te has postulado con éxito en la convocatoria:
              </div>
              <div className="col-12 font-size-16px font-family-Montserrat-SemiBold justify-content-center">
                Puede hacerle seguimiento desde el menú "Mis proyectos"
              </div>
            </div>

            {/*
              Quedo inscrita, pero con documentos por subsanar. Decirlo aqui,
              antes de que cierre el modal, es la unica ocasion de que se
              entere en el momento: despues tiene que entrar a buscarlo.
            */}
            {pendientes.length > 0 && (
              <div
                className="row mt-3 p-3"
                style={{ backgroundColor: "#FFF7E6", border: "1px solid #FFD591", borderRadius: 6 }}
              >
                <div className="col-12 font-family-Montserrat-SemiBold font-size-14px">
                  Tu propuesta quedó inscrita, pero te van a pedir subsanar ({pendientes.length})
                </div>
                <div className="col-12 font-family-Montserrat-Regular font-size-12px mt-1">
                  Esto quedó anotado en tu propuesta.{plazo ? ` ${plazo}` : ""}
                </div>
              </div>
            )}
            <div className="row border-top mt-4 justify-content-flex-center">
              <div className="col-6 justify-content-flex-end">
                <Button
                  className="button-blanco-radius mb-0"
                  onClick={handlePrint}
                >
                  DESCARGAR
                </Button>
              </div>
              <div className="col-6 justify-content-flex-start">
                <Button
                  className="button-azul-radius mb-0"
                  onClick={alAceptar}
                >
                  ACEPTAR
                </Button>
              </div>
            </div>
          </div>
          <div id="printThis" className="row-shadow mt-2">
            <div className="row">
              <div className="col-12 border-bottom font-family-Montserrat-Regular font-size-14px pb-3">
                Detalles
              </div>
            </div>
            <div
              className="row p-3"
              ref={componentRef}
              style={{ height: "600px", overflowY: "auto", fontSize: '10px', overflowWrap: 'break-word' }}
            >
              <table className="table table-bordered m-2">
                <caption style={{ display: 'none' }}>Detalle de postulación</caption>
                <tr>
                  <td className="table-light">Fecha:</td>
                  <td>{postulacion?.fecha_creacion}</td>
                </tr>
                <tr>
                  <td className="table-light">Código Radicado:</td>
                  <td>{postulacion?.radicado}</td>
                </tr>
                <tr>
                  <td className="table-light">Convocatoria:</td>
                  <td>{convocatoria?.nombre_convocatoria}</td>
                </tr>
                <tr>
                  <td className="table-light">Linea Convocatoria:</td>
                  <td>{postulacion?.linea_convocatoria}</td>
                </tr>
                <tr>
                  <td className="table-light">Línea Estratégica:</td>
                  <td>{convocatoria?.linea_estrategica}</td>
                </tr>
                <tr>
                  <td className="table-light">Nombre representante:</td>
                  <td>{postulacion?.primer_nombre} {postulacion?.primer_apellido}</td>
                </tr>
                <tr>
                  <td className="table-light">Tipo Participante:</td>
                  <td>{({"1": "Persona Natural", "2": "Persona Jurídica"} as Record<string,string>)[postulacion.tipo_participante] ?? "Grupo Conformado"}</td>
                </tr>
                <tr>
                  <td className="table-light">Nombre del proyecto:</td>
                  <td>{nombrepropuesta}</td>
                </tr>
                <tr>
                  <td className="table-light">Cédula/NIT:</td>
                  <td>{postulacion?.numero_documento_participante}</td>
                </tr>
                {pendientes.length > 0 && (
                  <tr>
                    <td className="table-light">Por subsanar:</td>
                    <td>
                      <ul style={{ paddingLeft: 16, margin: 0 }}>
                        {pendientes.map((aviso, indice) => (
                          <li key={`${aviso.documento}-${indice}`}>
                            <strong>{aviso.documento}:</strong> {aviso.texto}
                          </li>
                        ))}
                      </ul>
                      {plazo && <div style={{ marginTop: 6 }}>{plazo}</div>}
                    </td>
                  </tr>
                )}
              </table>
            </div>
          </div>
        </Modal>
  );
};
